import { render, staticRenderFns } from "./instAbsoluteBox.vue?vue&type=template&id=5a993d6f"
import script from "./instAbsoluteBox.vue?vue&type=script&lang=js"
export * from "./instAbsoluteBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports